/** @format */

import React, { FC, memo } from 'react'
import { _$, Breadcrumb, BreadcrumbItem } from 'kpc-react'
import styled from 'styled-components'
// import useGlobalData from 'src/hooks/useGlobalData'

interface BreadPrps {
  className?: string
  breadArr?: RouterState[]
  rightComponent?: React.ReactElement
  children?: React.ReactElement
}

interface RouterState {
  title: string
  route?: string
}

const Bread: FC<BreadPrps> = memo(({ className, breadArr, rightComponent, children }) => {
  return (
    <div className={className}>
      <p className="breadcrumb-text">
        <Breadcrumb separator="/">
          {breadArr?.length &&
            breadArr.map(({ route, title }, i) => {
              return (
                <BreadcrumbItem
                  key={`${route}-${title}`}
                  className={route ? 'crumbItem' : 'crumbItem cursor-pointer'}
                  to={route}
                >
                  {_$(title)}
                </BreadcrumbItem>
              )
            })}
          {children || ''}
        </Breadcrumb>
      </p>
      {rightComponent ? <div className="kfc-breadcrumb-right">{rightComponent}</div> : ''}
    </div>
  )
})

export default styled(Bread)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  flex-wrap: wrap;
  line-height: 50px;
  .breadcrumb-text {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .ion-chevron-left {
      margin-right: 8px;
    }
  }
  .crumbItem {
    display: inline-block;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #262626;
  }
`
